"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEligibilityCoachConsoService = exports.renameSectionSubscriptionService = exports.updateFamilyService = exports.createFamilyService = exports.deleteFamilyService = exports.updateContractNameService = exports.removeContractService = exports.addContract = exports.fetchClientsAccountsService = void 0;
var axiosInstance_1 = __importDefault(require("../helper/axiosInstance"));
var index_1 = require("../index");
var common_1 = require("./common");
function fetchClientsAccountsService(token, clientId, version) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    if (version === 'v1') {
                        route = "/users/website_areas/".concat(clientId);
                    }
                    else {
                        route = "/users/v2/website_areas/".concat(clientId);
                    }
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.fetchClientsAccountsService = fetchClientsAccountsService;
// no return needed, effect function depends on error catching
var deleteFamilyService = function (token, familyId) { return __awaiter(void 0, void 0, void 0, function () {
    var config, route, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!index_1.urlsConfig.values)
                    throw Error('No urls config found');
                config = { headers: { Authorization: "Bearer ".concat(token) } };
                route = "/users/families/".concat(familyId);
                return [4 /*yield*/, axiosInstance_1.default.delete("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route), config)];
            case 1:
                response = _a.sent();
                (0, common_1.LogRequestResponse)(response);
                return [2 /*return*/];
        }
    });
}); };
exports.deleteFamilyService = deleteFamilyService;
function createFamilyService(createFamilPayload, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, url, familyToCreate, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/users/families";
                    url = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
                    familyToCreate = {
                        clientId: createFamilPayload.clientId,
                        familyName: createFamilPayload.familyName,
                        familyPairingTechnologyCode: createFamilPayload.familyPairingTechnologyCode,
                        sectionsSubscriptionIds: createFamilPayload.sectionsSubscriptions.map(function (s) { return s.sectionSubscriptionId; })
                    };
                    return [4 /*yield*/, axiosInstance_1.default.post(url, familyToCreate, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.createFamilyService = createFamilyService;
function updateFamilyService(familyPayload, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, url, updateFamilPayload, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/users/families/".concat(familyPayload.family.familyId);
                    url = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
                    updateFamilPayload = {
                        clientId: familyPayload.clientId,
                        familyName: familyPayload.family.familyName,
                        familyId: familyPayload.family.familyId,
                        familyPairingTechnologyCode: familyPayload.family.familyPairingTechnologyCode,
                        sectionsSubscriptionIds: familyPayload.family.sectionSubscriptions.map(function (s) { return s.sectionSubscriptionId; })
                    };
                    return [4 /*yield*/, axiosInstance_1.default.put(url, updateFamilPayload, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.status];
            }
        });
    });
}
exports.updateFamilyService = updateFamilyService;
function renameSectionSubscriptionService(sectionSupscriptionPayload, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, url, updateNamePayload, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/users/section_subscriptions/".concat(sectionSupscriptionPayload.sectionSubscriptionId, "/name");
                    url = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
                    updateNamePayload = {
                        Name: sectionSupscriptionPayload.sectionSubscriptionName
                    };
                    return [4 /*yield*/, axiosInstance_1.default.patch(url, updateNamePayload, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response];
            }
        });
    });
}
exports.renameSectionSubscriptionService = renameSectionSubscriptionService;
function addContract(clientReference, clientName, contractName, token, version) {
    if (contractName === void 0) { contractName = ''; }
    if (version === void 0) { version = 'v1'; }
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    if (version === 'v1') {
                        route = "/users/website_areas";
                    }
                    else {
                        route = "/users/v2/website_areas";
                    }
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route), {
                            clientReference: clientReference,
                            clientName: clientName,
                            contractName: contractName
                        }, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data];
            }
        });
    });
}
exports.addContract = addContract;
function updateContractNameService(contractName, clientid, token) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = {
                        headers: {
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    route = "/users/user_websiteareas/".concat(clientid);
                    body = {
                        contractName: contractName
                    };
                    return [4 /*yield*/, axiosInstance_1.default.patch("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.updateContractNameService = updateContractNameService;
function removeContractService(token, clientAccountId) {
    return __awaiter(this, void 0, void 0, function () {
        var config, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/users/website_areas/".concat(clientAccountId);
                    return [4 /*yield*/, axiosInstance_1.default.delete("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.removeContractService = removeContractService;
function getEligibilityCoachConsoService(token, customerAccountId, locale) {
    if (locale === void 0) { locale = 'en'; }
    return __awaiter(this, void 0, void 0, function () {
        var config, route, url, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    route = "/users/coach_conso/customers/".concat(customerAccountId, "/neighbor_comparison?locale=").concat(locale);
                    url = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route);
                    return [4 /*yield*/, axiosInstance_1.default.get(url, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response];
            }
        });
    });
}
exports.getEligibilityCoachConsoService = getEligibilityCoachConsoService;
